import { render, staticRenderFns } from "./HomeSliderHeader.vue?vue&type=template&id=b1de0ffe"
import script from "./HomeSliderHeader.vue?vue&type=script&lang=js"
export * from "./HomeSliderHeader.vue?vue&type=script&lang=js"
import style0 from "./HomeSliderHeader.vue?vue&type=style&index=0&id=b1de0ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports